import { inboxService } from '@/services'

export default {
  state: {
    notifications: {
      personal: [],
      general: []
    }
  },

  mutations: {
    setNotifications (state, value) {
      state.notifications = value
    },

    updateNotificationStatus (state, { ids }) {
      state.notifications.personal = state.notifications.personal?.map(item => {
        if (ids.includes(item.id)) {
          return {
            ...item,
            status: 'read'
          }
        }
        return item
      })

      state.notifications.general = state.notifications.general?.map(item => {
        if (ids.includes(item.id)) {
          return {
            ...item,
            status: 'read'
          }
        }
        return item
      })
    },

    deleteNotification (state, { id, category }) {
      state.notifications[category] = state.notifications[category]?.filter(item => item.id !== id)
    },

    addNotification (state, value) {
      const notifications = state.notifications[value.category]

      notifications.unshift(value)

      state.notifications[value.category] = notifications
    }
  },

  actions: {
    async getNotifications ({ commit, getters }) {
      if (getters.isTeamAccount) {
        const { data } = await inboxService.getAll()
        commit('setNotifications', data.notifications)
        return data.notifications
      }
    },

    async updateNotificationStatus ({ commit }, { ids }) {
      await inboxService.update({ ids })
      commit('updateNotificationStatus', { ids })
    },

    async deleteNotification ({ commit }, { id, category }) {
      await inboxService.delete({ id })
      commit('deleteNotification', { id, category })
    }
  }
}
